import React from 'react';
import EmojiIcon from '#web-components/components/Icons/EmojiIcon';
import type { EmojiIconProps } from '#web-components/components/Icons/EmojiIcon/EmojiIcon';
// https://emojipedia.org/fire/
export default function ProhibitedIcon(props: Omit<EmojiIconProps, 'children'> = {}) {
  return (
    <EmojiIcon {...props}>🚫</EmojiIcon>
  );
}
